import { Button, ModalV3, useTranslation } from '@helios/frontend-core';

import { Themes } from '@palmetto/dsm-tokens';
import LogoIcon from '../../assets/logo/logo-icon.svg?react';
import SolarFigure from './assets/solar-figure-desktop.webp';
import { getAppDownloadLink } from '../../config';

interface OnboardingCompletionTakeoverProps {
  isOpen: boolean;
  onDismiss: () => void;
  projectId?: string;
}

const OnboardingCompletionTakeover: React.FC<OnboardingCompletionTakeoverProps> = ({ isOpen, onDismiss }) => {
  const TRACKING_ID = 'onboarding-completion-takeover';
  const { t } = useTranslation();

  const handleCtaClick = () => {
    window.open(getAppDownloadLink(), '_blank');
    onDismiss();
  };

  const ctaButton = (
    <div className="px-4">
      <Button trackingId={`${TRACKING_ID}-cta`} emphasis="primary" onClick={handleCtaClick}>
        {t('onboardingFinalization.completion.cta')}
      </Button>
    </div>
  );

  return (
    <ModalV3 open={isOpen} onClose={onDismiss} trackingId={TRACKING_ID} theme={Themes.core} cta={ctaButton}>
      <div className="flex flex-col gap-16 px-4">
        <div className="flex flex-col">
          <h2 className="heading-400 text-text-primary">{t('onboardingFinalization.completion.title')}</h2>
          <h2 className="heading-400 text-text-primary">{t('onboardingFinalization.completion.subtitle')}</h2>
        </div>
        <div className="flex flex-col gap-20">
          <div className="flex flex-row gap-12">
            <div className="relative flex-shrink-0 w-[80px] h-[80px]">
              <img src={SolarFigure} alt="" className="w-full h-full rounded-16" />
              <span className="absolute -bottom-4 -right-4 flex items-center justify-center w-24 h-24 bg-canvas-success text-grey-50 border-2 border-grey-50 rounded-full text-sm font-semibold">
                1
              </span>
            </div>
            <div className="flex flex-col gap-6">
              <span className="label-500 text-text-secondary">
                {t('onboardingFinalization.completion.cards.installer.title')}
              </span>
              <span className="body-400 text-text-secondary">
                {t('onboardingFinalization.completion.cards.installer.description')}
              </span>
            </div>
          </div>
          <div className="flex flex-row gap-12">
            <div className="relative flex-shrink-0 w-[80px] h-[80px]">
              <LogoIcon className="w-full h-full" />
              <span className="absolute -bottom-4 -right-4 flex items-center justify-center w-24 h-24 bg-canvas-success text-grey-50 border-2 border-grey-50 rounded-full text-sm font-semibold">
                2
              </span>
            </div>
            <div className="flex flex-col gap-6">
              <span className="label-500 text-text-secondary">
                {t('onboardingFinalization.completion.cards.app.title')}
              </span>
              <span className="body-400 text-text-secondary">
                {t('onboardingFinalization.completion.cards.app.description')}
              </span>
            </div>
          </div>
        </div>
      </div>
    </ModalV3>
  );
};

export default OnboardingCompletionTakeover;
